import { getAxios, getGraphql } from './apiUtils';
import * as moment from 'moment';
import * as R from 'ramda';
import gql from 'graphql-tag';
import { SHOWCASE_FIRM_ITEM } from './fragments/ShowcaseFirmItem.fragment';
import { SHOWCASE_FIRM_REPRESENTATIVE } from './fragments/ShowcaseFirmRepresentative.fragment';
import { ADSLOT_FIELDS } from './fragments/AdSlot.fragment';
import { SHOWCASE_FIRM } from './fragments/ShowcaseFirm.fragment';

// export const getAdSlots = async () => {
//   try {
//     const response = await getAxios().get('/api/adslot');
//     response.data.forEach(slot => {
//       slot.startDate = moment(slot.startDate, 'YYYY-MM-DD').toDate();
//       slot.endDate = moment(slot.endDate, 'YYYY-MM-DD').toDate();
//     });
//     return response.data;
//   } catch (error) {
//     throw new Error(error.message);
//   }
// };

export const getAdSlots = async variables => {
  const query = gql`
    ${ADSLOT_FIELDS}
    query GET_ADSLOTS($pageSize: Int!, $offset: Int!, $filter: showcaseAdslotFilter!) {
      showcaseAdslots(
        paging: { limit: $pageSize, offset: $offset }
        filter: $filter
        sorting: [{ field: dateCreated, direction: DESC }]
      ) {
        totalCount
        nodes {
          ...AdSlotFields
        }
      }
    }
  `;

  return getGraphql()
    .query({ query, variables })
    .then(results => {
      const slots = R.path(['data', 'showcaseAdslots', 'nodes'])(results);
      const count = R.path(['data', 'showcaseAdslots', 'totalCount'])(results);

      return { slots, count };
    });
};

export const getListingsForFirm = async variables => {
  const query = gql`
    ${ADSLOT_FIELDS}
    query GET_ADSLOTS($pageSize: Int!, $offset: Int!, $filter: showcaseAdslotFilter!) {
      showcaseAdslots(
        paging: { limit: $pageSize, offset: $offset }
        filter: $filter
        sorting: [{ field: dateCreated, direction: DESC }]
      ) {
        totalCount
        nodes {
          ...AdSlotFields
        }
      }
    }
  `;

  return getGraphql()
    .query({ query, variables })
    .then(results => {
      const slots = R.path(['data', 'showcaseAdslots', 'nodes'])(results);
      const count = R.path(['data', 'showcaseAdslots', 'totalCount'])(results);

      return { slots, count };
    });
};

export const searchAdSlots = async query => {
  try {
    const response = await getAxios().post('/api/adslot/search', query);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
export const getAdSlotById = async id => {
  try {
    const { data } = await getAxios().get('/api/adslot/' + id);
    return {
      ...data,
      startDate: moment(data.startDate).toDate(),
      endDate: moment(data.endDate).toDate(),
    };
  } catch (error) {
    throw new Error(error.message);
  }
};
export const cloneAdSlotById = async id => {
  try {
    return await getAxios()
      .post('/api/adslot/clone/' + id)
      .then(res => res.data);
  } catch (error) {
    throw new Error(error.message);
  }
};
export const addAdSlot = async slot => {
  try {
    const response = await getAxios().post('/api/adslot/', slot);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
export const updateAdSlot = async slot => {
  try {
    const response = await getAxios().put('/api/adslot/', slot);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
export const getListings = async () => {
  try {
    const response = await getAxios().get('/api/adslot-item');
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
export const getListingById = async id => {
  try {
    const response = await getAxios().get('/api/adslot-item/' + id);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const addListing = async listing => {
  try {
    const response = await getAxios().post('/api/adslot-item/', listing);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
export const updateListing = async listing => {
  try {
    const response = await getAxios().put('/api/adslot-item/', listing);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
export const getReps = async variables => {
  const query = gql`
    ${SHOWCASE_FIRM_REPRESENTATIVE}
    query GET_FIRM_REPS($pageSize: Int!, $offset: Int!, $filter: showcaseFirmRepresentativeFilter!) {
      showcaseFirmRepresentatives(
        paging: { limit: $pageSize, offset: $offset }
        filter: $filter
        sorting: [{ field: name, direction: ASC }]
      ) {
        totalCount
        nodes {
          ...ShowcaseFirmRepresentativeFields
        }
      }
    }
  `;

  return getGraphql()
    .query({ query, variables })
    .then(results => {
      const reps = R.path(['data', 'showcaseFirmRepresentatives', 'nodes'])(results);
      const count = R.path(['data', 'showcaseFirmRepresentatives', 'totalCount'])(results);
      return { reps, count };
    });
};

export const getRepById = async id => {
  try {
    const response = await getAxios().get('/api/showcase-firm-representative/' + id);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
export const addRep = async rep => {
  try {
    const response = await getAxios().post('/api/showcase-firm-representative/', rep);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
export const updateRep = async rep => {
  try {
    const response = await getAxios().put('/api/showcase-firm-representative/', rep);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
export const getFirms = async () => {
  try {
    const query = gql`
      ${SHOWCASE_FIRM}
      query GET_FIRMS {
        showcaseFirms(paging: { limit: 1000 }, sorting: [{ field: name, direction: ASC }]) {
          nodes {
            ...ShowcaseFirmFields
          }
        }
      }
    `;
    return getGraphql()
      .query({ query })
      .then(R.path(['data', 'showcaseFirms', 'nodes']))
      .then(firms => firms.filter(f => !f.isPaused));
  } catch (error) {
    throw new Error(error.message);
  }
};
export const getFirmsForLookup = async () => {
  try {
    const query = gql`
      query GET_FIRMS {
        showcaseFirms(paging: { limit: 1000 }, sorting: [{ field: name, direction: ASC }]) {
          nodes {
            id
            name
            userGroupId
          }
        }
      }
    `;
    return getGraphql()
      .query({ query })
      .then(R.path(['data', 'showcaseFirms', 'nodes']));
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getFirmById = async variables => {
  try {
    const query = gql`
      ${SHOWCASE_FIRM}
      query GET_FIRM($id: ID!) {
        showcaseFirm(id: $id) {
          ...ShowcaseFirmFields
        }
      }
    `;
    return getGraphql()
      .query({ query, variables })
      .then(R.path(['data', 'showcaseFirm']));
  } catch (error) {
    throw new Error(error.message);
  }
};

export const addFirm = async firm => {
  try {
    const response = await getAxios().post('/api/showcase-firm/', firm);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
export const updateFirm = async firm => {
  try {
    const response = await getAxios().put('/api/showcase-firm/', firm);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
export const searchFirms = async query => {
  try {
    const response = await getAxios().post('/api/showcase-firm/search', query);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const addFirmItem = async item => {
  try {
    const response = await getAxios().post('/api/showcase-firm-item', item);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
export const updateFirmItem = async item => {
  try {
    const response = await getAxios().put('/api/showcase-firm-item', item);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getFirmItems = async variables => {
  const query = gql`
    ${SHOWCASE_FIRM_ITEM}
    query GET_LISTINGS($pageSize: Int!, $offset: Int!, $filter: showcaseFirmItemFilter!) {
      showcaseFirmItems(
        paging: { limit: $pageSize, offset: $offset }
        filter: $filter
        sorting: [{ field: dateCreated, direction: ASC }]
      ) {
        totalCount
        nodes {
          ...ShowcaseFirmItemFields
        }
      }
    }
  `;

  return getGraphql()
    .query({ query, variables })
    .then(results => {
      const listings = R.path(['data', 'showcaseFirmItems', 'nodes'])(results);
      const count = R.path(['data', 'showcaseFirmItems', 'totalCount'])(results);
      return { listings, count };
    });
};

export const getFirmItemsByFirmId = async showcaseFirmId => {
  const query = gql`
    ${SHOWCASE_FIRM_ITEM}
    query GET_LISTINGS($showcaseFirmId: String) {
      showcaseFirmItems(
        filter: { showcaseFirmId: { eq: $showcaseFirmId } }
        sorting: [{ field: dateCreated, direction: DESC }]
      ) {
        nodes {
          ...ShowcaseFirmItemFields
        }
      }
    }
  `;

  return getGraphql()
    .query({ query, variables: { showcaseFirmId } })
    .then(results => {
      const showcaseFirmItems = R.path(['data', 'showcaseFirmItems', 'nodes'])(results);
      const count = R.path(['data', 'showcaseFirmItems', 'totalCount'])(results);
      return { showcaseFirmItems, count };
    });
};

export const searchListings = async query => {
  try {
    const response = await getAxios().post('/api/showcase-firm-item/search', query);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
export const getFirmItemById = async item => {
  try {
    const response = await getAxios().put('/api/showcase-firm-item/' + item.id);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
export const getItemsForFirms = async firmIds => {
  try {
    const response = await getAxios().post('/api/showcase-firm-item/list', { firmIds });
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
export const addFirmToOrganization = async assignment => {
  try {
    const response = await getAxios().post('/api/user-group/assign-firm', assignment);
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
